import React from "react";
import { Card, Button } from "react-bootstrap";
import "./About.css";
import logo from "../assets/images/coding.svg";

function About() {
  return (
    <div id="about" className="about">
      <div className="intro">
        <Card className="card">
          <Card.Header className="name" as="h5">
            Parmvir Shergill
          </Card.Header>{" "}
          <hr></hr>
          <Card.Body>
            <Card.Title>Software Developer @ Safe Software</Card.Title>
            <Card.Text>
              I am a software developer with a strong foundation in both Computer Science and Biology, having completed 
              degrees in both disciplines at the University of British Columbia. My passion lies in solving complex problems 
              and pushing the boundaries of system design. In my free time, I enjoy hiking and exploring the natural world.
            </Card.Text>
            <div className="linkButtons">
            <a href="mailto: parmvir.shergill@gmail.com" target="_blank" rel="noreferrer">
              <Button className="mButton" variant="success">Email Me</Button>
            </a>
            <a
              href="https://www.linkedin.com/in/parmvir-shergill-84208538/"
              target="_blank" rel="noreferrer"
            >
              <Button className="liButton" variant="success">
                LinkedIn
              </Button>
            </a>
            <a href="https://github.com/Parmvir-S" target="_blank" rel="noreferrer">
              <Button className="ghButton" variant="success">
                GitHub
              </Button>
            </a>
            </div>
          </Card.Body>
        </Card>
      </div>
      <div className="introPicture">
        <img className="introImg" alt="logo" src={logo} />
      </div>
    </div>
  );
}

export default About;
